import React from "react";
import {LoadingDialog} from "../../../../components/DialogLoading";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";

export enum MEASUREMENT_VISUALIZATION_MODAL_CONTENT {
  CONFIRM_DELETE = 'confirmDelete',
  LOADING = 'loading',
  DELETED = 'deleted',
}

export const MeasurementVisualizationModalContent = ({
  onConfirmDeleteMeasurement,
  onCloseDialog,
}) => ({
  [MEASUREMENT_VISUALIZATION_MODAL_CONTENT.CONFIRM_DELETE]: (
    <TwoButtonDialog
      type="warning"
      title="確定要刪除這筆資料嗎？"
      leftLabel="先不要"
      leftOnClick={onCloseDialog}
      rightLabel="刪除"
      rightColor="warning"
      rightOnClick={onConfirmDeleteMeasurement}
      rightIconName="fa-trash"
    />
  ),
  [MEASUREMENT_VISUALIZATION_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="載入中" />
  ),
  [MEASUREMENT_VISUALIZATION_MODAL_CONTENT.DELETED]: (
    <TwoButtonDialog
      type="success"
      title="已成功刪除"
      leftLabel="OK"
      leftOnClick={onCloseDialog}
    />
  )
})